import { render, staticRenderFns } from "./AddDress.vue?vue&type=template&id=53535f91&scoped=true"
import script from "./AddDress.vue?vue&type=script&lang=js"
export * from "./AddDress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53535f91",
  null
  
)

export default component.exports